<template>
    <client-only>
        <el-dialog 
            :align-center="alignCenter" 
            :show-close="showClose"
            :fullscreen="fullscreen"
            :width="width"
            @update:model-value="$emit('update:visible', $event)" 
            :model-value="visible"
            @close="close"
            v-bind="attrs"
            :custom-class="customClass"
        >
            {{ customClass }}
            <slot></slot>
        </el-dialog>
    </client-only>
</template>
<script setup lang="ts">
interface Props {
    alignCenter?: boolean,
    showClose?: boolean,
    visible: boolean,
    fullscreen: boolean,
    width?: string,
    customClass?: string,
}
const props = withDefaults(defineProps<Props>(), {
    alignCenter: true,
    showClose: false,
    visible: false,
    fullscreen: false,
    width: '50%',
    customClass: '',
})
const emit = defineEmits(['update:visible'])
const close = ()=>{
    emit('update:visible', false)
}

const attrs = useAttrs()

</script>
